import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/EInvoiceCompany";

export const Register = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Register`, options);

export const UpdateUyumCredentials = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateUyumCredentials`, options);

export const RotateApiKey = (options) =>
  GENERATE_URL(`${PREFIX_URL}/RotateApiKey`, options);

export const Deactivate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Deactivate`, options);

export default {
  Register,
  UpdateUyumCredentials,
  RotateApiKey,
  Deactivate,
};
